<template>
  <div class="Setup">
    <div class="Tit">安全设置</div>
    <div class="int">
      <div class="t fl">旧密码：</div>
      <div class="content fl">
        <el-input type="password" v-model="oldpassword" placeholder="请输入旧密码"></el-input>
      </div>
    </div>
    <div class="int">
      <div class="t fl">新密码：</div>
      <div class="content fl">
        <el-input type="password" v-model="password" placeholder="请输入新密码"></el-input>
      </div>
    </div>
    <div class="int">
      <div class="t fl">确认新密码：</div>
      <div class="content fl">
        <el-input @keyup.enter.native="setUp" type="password" v-model="repassword"
                  placeholder="请再次输入新密码"></el-input>
      </div>
    </div>
    <div @click="setUp" class="sure">确认设置</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        oldpassword: '',
        password: '',
        repassword: ''
      }
    },
    methods: {
      setUp () {
        if (this.oldpassword === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入旧密码'
          })
          return false
        }
        if (this.oldpassword === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入新密码'
          })
          return false
        }
        if (this.oldpassword === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请再次输入新密码'
          })
          return false
        }
        this.$http.post('/apipx/User/repwd', {
          oldpassword: this.oldpassword,
          password: this.password,
          repassword: this.repassword,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .Setup {
    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .int {
      margin: 20px 0 0 0;
      overflow: hidden;

      .t {
        width: 80px;
        text-align: right;
        font-size: 16px;
        height: 42px;
        line-height: 42px;
      }

      .content {
        width: 300px;
        height: 40px;
        border: 1px solid #c6c6c6;
        margin: 0 0 0 20px;
        border-radius: 5px;

        .el-input__inner {
          border: 0;
          width: 300px;
        }
      }
    }

    .sure {
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 300px;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      background-color: #ff8484;
      margin: 50px 0 0 100px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/Setup/Setup.vue